import { render } from "./add-school-administrator.vue?vue&type=template&id=06ad43b8&scoped=true"
import script from "./add-school-administrator.vue?vue&type=script&lang=js"
export * from "./add-school-administrator.vue?vue&type=script&lang=js"

import "./add-school-administrator.vue?vue&type=style&index=0&id=06ad43b8&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ad43b8"]])

export default __exports__